export enum AppearanceTypeEnum {
  Box = "Box", //Thùng
  Tray = "Tray", // Khay
}

export enum DemensionAndWeightAppearanceTypeEnum {
  None = "-", //Không
  Box = "Hộp", //Thùng
  Leaflet = "Toa", //Toa
  Label = "Nhãn", //Nhãn
  Blister = "Vỉ", //Vỉ
  PaperBoard = "Bìa", //Bìa
  CardBoard = "Ngăn", //Ngăn
}
